import { render, staticRenderFns } from "./RejectedPanel.vue?vue&type=template&id=0645efee&"
import script from "./RejectedPanel.vue?vue&type=script&lang=js&"
export * from "./RejectedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports